import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import classes from './CouponsList.module.scss'

const CouponsList = ({ certification }) => {
  const { t } = useTranslation()

  const description = (coupon) => [
    coupon.label,
    t('certificationBuilder.coupons.percentOff', { percent: coupon.percentOff }),
    coupon.expiresAt && t('certificationBuilder.coupons.until', { date: moment(coupon.expiresAt).format('ll') }),
    coupon.organization && t('certificationBuilder.coupons.organizationOnly', { name: coupon.organization.name }),
  ].filter(Boolean).join(' · ')

  const link = (coupon) => {
    if (coupon.chargebeeCouponId) { return { key: 'linked', icon: 'fa-link', className: classes.linked } }
    if (coupon.percentOff === 100) { return { key: 'freeNoLink', icon: 'fa-gift', className: classes.free } }

    return { key: 'notLinked', icon: 'fa-chain-broken', className: classes.unlinked }
  }

  const usesLabel = (coupon) => coupon.maxUses
    ? t('certificationBuilder.coupons.maxUses', { count: coupon.maxUses })
    : t('certificationBuilder.coupons.unlimitedUses')

  return (
    <div>
      <div className='d-flex align-items-baseline justify-content-between mb-2'>
        <span className={classes.label}>{t('certificationBuilder.coupons.title')}</span>
        <span className={classes.managed}>{t('certificationBuilder.coupons.managed')}</span>
      </div>

      {certification.coupons.length === 0 && <p className={classes.empty}>{t('certificationBuilder.coupons.empty')}</p>}

      <div className='d-flex flex-column'>
        {certification.coupons.map(coupon => (
          <div key={coupon.id} className={classes.row}>
            <span className={classes.code}>{coupon.code}</span>
            <span className={classes.description}>{description(coupon)}</span>
            <span
              className={classNames(classes.link, link(coupon).className)}
              title={coupon.chargebeeCouponId && t('certificationBuilder.coupons.chargebeeId', { id: coupon.chargebeeCouponId })}
            >
              <i className={classNames('fa', link(coupon).icon)} aria-hidden='true' />
              {t(`certificationBuilder.coupons.${link(coupon).key}`)}
            </span>
            <span className={classes.uses}>{usesLabel(coupon)}</span>
            <span className={classNames(classes.status, { [classes.statusActive]: coupon.active })}>
              {t(coupon.active ? 'certificationBuilder.coupons.active' : 'certificationBuilder.coupons.inactive')}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

CouponsList.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    coupons: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
      label: PropTypes.string,
      percentOff: PropTypes.number.isRequired,
      maxUses: PropTypes.number,
      expiresAt: PropTypes.string,
      active: PropTypes.bool.isRequired,
      chargebeeCouponId: PropTypes.string,
      organization: PropTypes.shape({ name: PropTypes.string.isRequired }),
    })).isRequired,
  }).isRequired,
}

export default CouponsList
